import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProjectsService from '../../services/ProjectsService';
import PostsService from '../../services/PostsService';
import ProjectCard from '../Projects/ProjectCard';
import PostCard from '../Posts/PostCard';
import { getActivePinnedItem } from '../../config/pinnedSchedule';
import ErrorBoundary from '../ErrorBoundary';

export default function PinnedCard() {
    return (
        <ErrorBoundary>
            <PinnedCardContent />
        </ErrorBoundary>
    );
}

function PinnedCardContent() {
    const [pinnedItem, setPinnedItem] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchPinnedItem = async () => {
            const pinnedConfig = getActivePinnedItem();

            if (!pinnedConfig) {
                setIsLoading(false);
                return;
            }

            try {
                const [type, id] = pinnedConfig.split('-');

                if (!type || !id) {
                    setIsLoading(false);
                    return;
                }

                let item;
                if (type === 'post') {
                    item = await PostsService.getPinnedPost(id);
                } else if (type === 'project') {
                    item = await ProjectsService.getPinnedProject(id);
                } else {
                    setIsLoading(false);
                    return;
                }

                if (!item || !item.id) {
                    console.warn('Pinned item not found, hiding sponsored card:', pinnedConfig);
                    setIsLoading(false);
                    return;
                }

                setPinnedItem(item);
            } catch (error) {
                console.error('Error fetching pinned item:', error);
            }

            setIsLoading(false);
        };

        fetchPinnedItem();
    }, []);

    if (isLoading || !pinnedItem) {
        return null;
    }

    return (
        <div className="mb-6">
            <div className="-mb-1 flex justify-end">
                <Link
                    to="/sponsor"
                    className="inline-block bg-purple-500 text-white px-2 py-1 rounded-md text-sm font-bold hover:underline"
                >
                    Sponsored
                </Link>
            </div>

            {pinnedItem.feedType === 'project' ? (
                    <ProjectCard
                        key={pinnedItem.id + 'proj'}
                        category="everyone"
                        id={pinnedItem.id}
                        claps={pinnedItem.claps}
                        hideActions={true}
                        name={pinnedItem.name}
                        description={pinnedItem.description}
                        images={pinnedItem.images}
                        url={pinnedItem.url}
                        forSale={pinnedItem.forSale}
                        userId={pinnedItem.userId}
                        fullName={pinnedItem.fullName}
                        username={pinnedItem.username}
                        avatar={pinnedItem.avatar}
                        bio={pinnedItem.bio}
                        createdAt={pinnedItem.createdAt}
                        commentsCount={pinnedItem.comments}
                        isPinned={true}
                    />
                ) : (
                    <PostCard
                        key={pinnedItem.id + 'post'}
                        category="everyone"
                        id={pinnedItem.id}
                        claps={pinnedItem.claps}
                        hideActions={true}
                        images={pinnedItem.images}
                        userId={pinnedItem.userId}
                        fullName={pinnedItem.fullName}
                        username={pinnedItem.username}
                        avatar={pinnedItem.avatar}
                        bio={pinnedItem.bio}
                        createdAt={pinnedItem.createdAt}
                        message={pinnedItem.message}
                        projectId={pinnedItem.projectId}
                        projectName={pinnedItem.projectName}
                        commentsCount={pinnedItem.comments}
                        isPinned={true}
                    />
                )}
        </div>
    );
}